import {
	SUBSCRIPTIONS_SORT_VALUE,
	SINGLE_SUBSCRIPTION,
	SET_SUPPRESSION_STEP
} from "./actions";

const initialState = {
	subscriptionsSortValue: "-statistics.updated",
	singleSubscription: null,
	currentStep: "select"
};

export const reducer = (state = initialState, action) => {
	
	
	switch (action.type) {
		case SUBSCRIPTIONS_SORT_VALUE:
			return {
				...state,
				subscriptionsSortValue: action.subscriptionsSortValue
			};
		case SINGLE_SUBSCRIPTION:
			return {
				...state,
				singleSubscription: action.singleSubscription
			};
		case SET_SUPPRESSION_STEP:
			return {
				...state,
				currentStep: action.payload
			}
		default:
			return state;
	}
};
